import {ComponentFactoryResolver, EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogModel} from '@shared/models/dialog.model';
import {HttpClient} from '@angular/common/http';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {ProjectState} from '@features/projects/store/reducers/projects.reducer';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {FileManagementService} from '@core/services/file-management.service';
import {FilingManagerService} from '@features/due-date-tracker/services/filing-manager.service';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {FuseSidebarService} from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import {MatDialog} from '@angular/material/dialog';
import {PlatformSidebarService} from '@shared/components/platform-sidebar/store/platform-sidebar.service';
import {take, takeUntil} from 'rxjs/operators';
import {SetReplacementPowerBiFilters} from '@shared/store/actions/particle.actions';
import {Subject} from 'rxjs';
import {FileDialogComponent} from '@features/file-manager/component/file-dialog/file-dialog.component';

@Injectable({
  providedIn: 'root',
})

export class Pillar2complianceHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  readonly settingsChanged$ = new Subject<void>();
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  sourceType: string;
  unsubscribe$ = new Subject<void>();
  deleteFutureTask = false;
  metaData: any = {};
  selectedTabModel: any;
  unSubscribe$ = new Subject<void>();
  constructor(private httpClient: HttpClient,
              private commandService: CommandService,
              private router: Router,
              private taskManagerService: TaskManagerService,
              private dialogService: DialogService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private componentFactoryResolver: ComponentFactoryResolver,
              private store: Store<IQueryState>,
              private projectStore: Store<ProjectState>,
              private particleStore: Store<ParticleState>,
              private fileManagementService: FileManagementService,
              private filingManagerService: FilingManagerService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private sidebarService: FuseSidebarService,
              private dialog: MatDialog,
              private platformSidebarService: PlatformSidebarService) {
  }

  destroy(): void {
  }
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }
  executeCommand(command: PlatformCommand, callBack?: any) {
    if (command.fieldValues['DialogDefinition']) {
      delete command.fieldValues['DialogDefinition'];
    }
    if (command.fieldValues['ReturnStatus']) {
      delete command.fieldValues['ReturnStatus'];
    }
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
      return;
    }
    if (command.name === 'CreatePillar2StatusSettingsCommand') {
      const boardId = command.fieldValues['BoardId'];
      this.taskManagerService.openTaskStatusSettings(boardId, 1).pipe(takeUntil(this.unsubscribe$)).subscribe(xx => {
        if (xx?.action === 'OK') {
          this.settingsChanged$.next();
        }
        this.invalidateSubject.invalidate();
      });
    } else if (command.name === 'CreatePillar2ConsolidatedFilingSettingsCommand'){
      if (this.selectedTabModel && this.selectedTabModel.tabData) {
        command.fieldValues['FieldSectionId'] = this.selectedTabModel.tabData['FIELD_SECTION_ID'];
        this.executeCommandToApi(command);
      }
    } else if (command.name === 'ExportPillar2ComplianceCommand') {
      this.showExportDialog(command);
    } else {
      this.executeCommandToApi(command);
    }
  }
  showExportDialog(command: PlatformCommand) {
    const title = command.fieldValues['Title'];
    const dialogModel = DialogModel.create('Export', 'DueDateFilingExportOptionsDialogComponent', {clickAction: new EventEmitter<any>(), title: title});
    this.dialogService.showOkCancelDialog(dialogModel).subscribe( actionState => {
      console.log(actionState);
    });
    dialogModel.input['clickAction'].pipe(takeUntil(this.unSubscribe$)).subscribe(option => {
      if (option.includes('download')) {
        command.fieldValues['SaveToDrive'] = false;
        this.executeCommandToApi(command);
        const fileType = option.split('-')[1];
        //this.saveToDrive(this.executionId, fileType, dialogModel.input['ExportOption']);
      } else {
        this.saveToDrive(command);
        //this.downloadForm(option, dialogModel.input['ExportOption'], exportCommandResopnse);
      }
    });
  }
  saveToDrive(command: PlatformCommand) {
    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        itemsUrlIndex: 1,
        type: 'SharedDrives',
        folderId: '',
        driveId: '',
        isFileSelector: false,
        viewType: 'TeamDrive',
        title: 'Select Folder'
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: any) => {
      console.log(result);
      command.fieldValues['SaveToDrive'] = true;
      command.fieldValues['RelativePath'] = result.cells.RelativePath.value;
      command.fieldValues['DriveId'] = result.cells.DriveId.value;
      this.executeCommandToApi(command);
      this.snackBarService.showInformation('Saved to drive successfully.');
    });
  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      const skipInvalidate = command.fieldValues['NoInvalidate'] === true;
      if (!skipInvalidate) {
        this.fuseSplashScreenService.show();
      }
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          if (!skipInvalidate) {
            this.fuseSplashScreenService.hide();
          }
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            if (this.router.url.split('/').pop() === commandResponse.fieldValues['RedirectUrl'].split('/').pop()){
              this.invalidateSubject.invalidate('Refresh');
            } else {
              this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            }
          } else if (commandResponse.fieldValues['FileId']) {
            this.downloadFileByFileId(commandResponse.fieldValues['FileId'], commandResponse.fieldValues['Title']);
          } else if (commandResponse.fieldValues['SnackBarMessage']) {
            if (!skipInvalidate) {
              this.invalidateSubject.invalidate();
            }
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 100;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          } else if (commandResponse.fieldValues['Error']) {
            const duration = commandResponse.fieldValues['Error'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['Error'], duration);
          } else if (commandResponse.name === 'UpdateCardViewFieldItemCommand') {
            this.invalidateSubject.invalidate('Refresh');
          } else if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.invalidateSubject.invalidate('Refresh');
          } else if (commandResponse.name === 'AddOccurrenceCommand') {
            this.invalidateSubject.invalidate('Refresh');
          } else if (commandResponse.name === 'DeleteOccurrenceCommand') {
            this.invalidateSubject.invalidate('Refresh');
          } else if (!skipInvalidate) {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          if (!skipInvalidate) {
            this.fuseSplashScreenService.hide();
          }
        });
    }

  }
  private downloadFileByFileId(fileId: string, title: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).pipe(take(1)).subscribe(payload => {
      this.fuseSplashScreenService.hide();
      this.fileManagementService.openSaveFileWindow(payload, title + '.xlsx');
    }, err => {
      this.fuseSplashScreenService.hide();
      this.snackBarService.showError('Unable to download file');
      console.error(err);
    });
  }

  valueChanged(event) {
    if (event?.command) {
      if (event.command.name === 'Pillar2ComplianceFormClickCommand' || event.command.name === 'Pillar2ComplianceSetSelectedFormCommand') {
        event.command.api = this.pageApi();
      }
      this.executeCommand(event.command);
      return;
    }
    if (this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`]) {
      const command = this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`];
      command.fieldValues['FilingId'] = event.item.id;
      command.fieldValues['FieldKey'] = event.fieldDefinition.key;
      command.fieldValues['FieldSectionId'] = event.fieldSection.id;
      command.fieldValues['HasDialogInput'] = false;
      command.fieldValues['FieldValue']=event.item.cells[event.fieldDefinition.key];
      if (event.action && event.action.id) {
        command.fieldValues['Action'] = event.action.id;
      }
      this.executeCommand(command);
    } else if (event.action) {
      if (this.magicLinkModel.additionalCommands[`${event.action.id}LinkCommand`]) {
        const command = this.magicLinkModel.additionalCommands[`${event.action.id}LinkCommand`];
        command.fieldValues['FilingId'] = event.item.id;
        command.fieldValues['FieldKey'] = event.fieldDefinition.key;
        command.fieldValues['FieldSectionId'] = event.fieldSection.id;
        command.fieldValues['HasDialogInput'] = false;
        this.executeCommand(command);
      }  else {
        switch (event.action.id) {
          case 'Edit':
            this.edit(event);
            break;
          case 'Task':
            this.showOrAddTask(event);
            break;
          case 'Reset':
            this.resetCommand(event);
            break;
        }
      }
    }
  }

  edit(event) {
    let componentName = '';
    switch (event.fieldDefinition.cellViewer) {
      case 'YesNoCellViewerComponent':
      case 'YesNoWithNoteCellViewerComponent':
        componentName = 'YesNoDialogEditorComponent';
        break;
      case 'SurrogateCellViewerComponent':
        componentName = 'SurrogateDialogEditorComponent';
        break;
      case 'DueDateCellViewerComponent':
        const additionalCommand = 'UpdateDueDateCommand';
        if (this.magicLinkModel.additionalCommands[additionalCommand]) {
          const command = this.magicLinkModel.additionalCommands[additionalCommand];
          command.fieldValues['FilingId'] = event.item.id;
          command.fieldValues['FieldKey'] = event.fieldDefinition.key;
          command.fieldValues['SelectedFieldKey'] = event.fieldDefinition.key;
          command.fieldValues['FieldSectionId'] = event.fieldSection.id;
          command.fieldValues['DialogTitle'] = event.fieldDefinition.header;
          this.executeCommand(command);
        }
        break;
    }
    if (!componentName) {
      return;
    }
    const dialogModel = DialogModel.create(event.fieldDefinition.header, componentName, {
      fieldDefinition : event.fieldDefinition,
      item : event.item
    } , '800px');
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(2)).subscribe(state => {
      if (state.action === 'OK') {
        if (dialogModel.input['selectedValue'] != null) {
          this.fuseSplashScreenService.show();
          const command = new PlatformCommand('UpdatePillar2ComplianceFilingCommand', this.pageApi());
          command.fieldValues['UpdateType'] = 'RequiredFields';
          command.fieldValues['Value'] = dialogModel.input['selectedValue'];
          command.fieldValues['FilingId'] = event.item.id;
          command.fieldValues['FieldKey'] = event.fieldDefinition.key;
          this.commandService.executePlatformCommand(command).pipe().subscribe(res => {
            this.invalidateSubject.invalidate();
            this.fuseSplashScreenService.hide();
          });
        }
        this.invalidateSubject.invalidate();
      }
    });
  }

  showOrAddTask(event) {
    if (event.item.cells[event.fieldDefinition.key]
      && event.item.cells[event.fieldDefinition.key].value
      && event.item.cells[event.fieldDefinition.key].value.taskId) {
      this.taskManagerService.openTaskByTaskId(event.item.cells[event.fieldDefinition.key].value.taskId, 'COMPANY').subscribe(state => {
        this.invalidateSubject.invalidate();
      });
    } else if (this.magicLinkModel.additionalCommands['AddTaskLinkCommand']) {
      const command = this.magicLinkModel.additionalCommands['AddTaskLinkCommand'];
      command.fieldValues['FilingId'] = event.item.id;
      command.fieldValues['FieldKey'] = event.fieldDefinition.key;
      command.fieldValues['FieldSectionId'] = event.fieldSection.id;
      this.executeCommand(command);
    }
  }

  private resetCommand(event: any) {
    this.fuseSplashScreenService.show();
    const command = new PlatformCommand('UpdatePillar2ComplianceFilingCommand', this.pageApi());
    command.fieldValues['UpdateType'] = 'RequiredFields';
    command.fieldValues['Value'] = '';
    command.fieldValues['FilingId'] = event.item.id;
    command.fieldValues['FieldKey'] = event.fieldDefinition.key;
    command.fieldValues['Action'] = 'Reset';
    this.commandService.executePlatformCommand(command).pipe().subscribe(res => {
      this.invalidateSubject.invalidate();
      this.fuseSplashScreenService.hide();
    });
  }

  // The Api of the page's own command: DueDateTrackerApi on the DDT page, SpreadsheetApi on the legacy page.
  private pageApi(): string {
    return this.selectedTabModel?.tabData?.['Api'] ?? this.magicLinkModel?.additionalCommands?.['UpdateDueDateCommand']?.api ?? 'SpreadsheetApi';
  }
}
